import React from "react";
import { AiOutlineArrowLeft, AiOutlineArrowRight, AiOutlineFastBackward, AiOutlineFastForward } from "react-icons/ai";

const MAX_WINDOW = 9;
/** Si hay pocas páginas, mostrar todas; si no, ventana deslizante alrededor de la actual */
const SHOW_ALL_CAP = 12;

export function Pagination({ currentPage, onPageChange, totalPages }) {
  if (totalPages <= 0) {
    return null;
  }

  const pageButtonIndices = () => {
    if (totalPages <= SHOW_ALL_CAP) {
      return Array.from({ length: totalPages }, (_, i) => i);
    }
    const half = Math.floor(MAX_WINDOW / 2);
    let start = Math.max(0, currentPage - half);
    let end = start + MAX_WINDOW;
    if (end > totalPages) {
      end = totalPages;
      start = Math.max(0, end - MAX_WINDOW);
    }
    return Array.from({ length: end - start }, (_, i) => start + i);
  };

  const renderPages = () => {
    const indices = pageButtonIndices();
    const pages = [
      <div
        key={`page_primera`}  
      >
        <button
          disabled={currentPage === 0}
          onClick={() => {
            onPageChange(0);
          }}
          className="bg-purple text-white p-2 w-8 h-8 disabled:opacity-50"
        >
          <AiOutlineFastBackward className="h-4" />
        </button>
      </div>,
      <div
        key={`page_anterior`}
      >
        <button
          disabled={currentPage === 0}
          onClick={() => {
            onPageChange(currentPage - 1);
          }}
          className="bg-purple text-white p-2 w-8 h-8 disabled:opacity-50"
        >
          <AiOutlineArrowLeft className="h-4" />
        </button>
      </div>,
    ];
    if (indices[0] > 0) {
      pages.push(
        <span key="ellipsis_start" className="px-1 text-purple self-center">
          …
        </span>
      );
    }
    for (const index of indices) {
      pages.push(
        <button
          key={`page_${index + 1}`}
          onClick={() => {
            onPageChange(index);
          }}
          className={`${currentPage === index ? "bg-orange" : "bg-purple"} text-white p-2 w-8 h-8 flex items-center justify-center`}
        >
          {index + 1}
        </button>
      );
    }
    if (indices.length && indices[indices.length - 1] < totalPages - 1) {
      pages.push(
        <span key="ellipsis_end" className="px-1 text-purple self-center">
          …
        </span>
      );
    }
    pages.push(
      <div
        key={`page_siguiente`}
      >
        <button
          disabled={currentPage === totalPages - 1}
          onClick={() => {
            onPageChange(currentPage + 1);
          }}
          className="bg-purple text-white p-2 w-8 h-8 disabled:opacity-50"
        >
          <AiOutlineArrowRight className="h-4" />
        </button>
      </div>
    );
    pages.push(
      <div
        key={`page_ultima`}
      >
        <button
          disabled={currentPage === totalPages - 1}
          onClick={() => {
            onPageChange(totalPages - 1);
          }}
          className="bg-purple text-white p-2 w-8 h-8 disabled:opacity-50"
        >
          <AiOutlineFastForward className="h-4" />
        </button>
      </div>
    );
    return pages;
  };

  return (
    <div className="my-8">
      <div className="w-full flex flex-wrap gap-1 justify-center">
        {renderPages()}
      </div>
    </div>
  );
}

export default Pagination;
